import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { UIState } from '../types/ui';

export const useUIStore = create<UIState>()(
  devtools(
    set => ({
      errorModal: { open: false, title: '', message: '' },
      loadingCount: 0,
      changeTargetMsisdnOpen: false,

      showError: ({ title = '', message }) =>
        set({ errorModal: { open: true, title, message } }, false, 'showError'),

      hideError: () =>
        set(
          { errorModal: { open: false, title: '', message: '' } },
          false,
          'hideError',
        ),

      showLoading: () =>
        set(
          state => ({ loadingCount: state.loadingCount + 1 }),
          false,
          'showLoading',
        ),
      hideLoading: () =>
        set(
          state => ({ loadingCount: Math.max(0, state.loadingCount - 1) }),
          false,
          'hideLoading',
        ),

      showChangeTargetMsisdn: () =>
        set({ changeTargetMsisdnOpen: true }, false, 'showChangeTargetMsisdn'),
      hideChangeTargetMsisdn: () =>
        set({ changeTargetMsisdnOpen: false }, false, 'hideChangeTargetMsisdn'),
    }),
    { name: 'UIStore' },
  ),
);
